// Built-in import
import * as React from "react";
// External import

import { Box, Stack, Typography } from "@mui/material"
import { limitChar } from "@/utils"
import StatusBox from "@/components/shared/status-box"
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";

interface IDescriptionCard {
  description: string;
  status: string;
}

const DescriptionCard: React.FC<IDescriptionCard> = ({ description ,status}) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",

          width: "30px",
          height: "30px",
          borderRadius: "50%",
          backgroundColor: "#f0f0f0",
          marginRight: "8px"
        }}
      >
        <BusinessRoundedIcon sx={{ fontSize: "20px" }} />
      </Box>
      <Typography variant="smallMedium" color="text.primary" >
        {limitChar(description, 45)}
      </Typography>
    </Box>
    <StatusBox status={status} />
  </Stack>
  )
}


export default DescriptionCard;